import { Selector, State } from "./types";
import { editUnavailabilityError } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isEditUnavailabilityRequestFailure({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isEditUnavailabilityRequestPending({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isEditUnavailabilityRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
    getEditUnavailabilityError({ uuid }) {
      const req = getState().find(
        ({ unavailability }) => unavailability.uuid === uuid,
      );

      return req ? req.error : editUnavailabilityError;
    },
  };
}

export { createSelector };
